declare global {
    interface Window {
        dataLayer: any[];
    }
}

const eventToGTM = (name: string, params: object = {}) => {
    window.dataLayer = window.dataLayer || []

    if (name) {
        window.dataLayer.push({
            event: name,
            ...params,
        })
    }
}

export default eventToGTM
